import { graphql } from 'react-relay';
import type {
	useMigratedRecentlyMigratedRecentlyQuery as useMigratedRecentlyMigratedRecentlyQuery$data,
	useMigratedRecentlyMigratedRecentlyQueryVariables as useMigratedRecentlyMigratedRecentlyQuery$variables,
} from './__types__/useMigratedRecentlyMigratedRecentlyQuery.ts';
// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports
import { useQueryInterop } from '@confluence/apollo-relay-interop/entry-points/useQueryInterop.ts';
export const useMigratedRecently = (contentId: string): boolean => {
	const { data, loading, error } = useQueryInterop<
		useMigratedRecentlyMigratedRecentlyQuery$data,
		useMigratedRecentlyMigratedRecentlyQuery$variables
	>(
		graphql`
			query useMigratedRecentlyMigratedRecentlyQuery($contentId: ID!) {
				content(id: $contentId) {
					nodes {
						id
						metadata {
							frontend {
								migratedRecently
							}
						}
					}
				}
			}
		`,
		{
			variables: { contentId },
		},
	);

	if (loading || error) {
		return false;
	}

	return data?.content?.nodes?.[0]?.metadata?.frontend?.migratedRecently || false;
};
